const scrollSpeed = 750;

const SmoothAnchors = {
	bindEvents: () => {
		/*
		 * Smooth Scroll Anchors
		 * Smooth scrolling on page load if URL have a hash
		 */
		if (window.location.hash) {
			const hash = window.location.hash;
			const element = document.querySelector(hash);
			if (element) {
				SmoothAnchors.scrollToElement(hash);
			}
		}

		/**
		 * Smooth scrolling to page anchor on click
		 **/
		document.querySelectorAll("a[href*='#']:not([href='#'])").forEach((link) => {
			link.addEventListener('click', function (e) {
				if (
					location.hostname == this.hostname &&
					this.pathname.replace(/^\//, '') == location.pathname.replace(/^\//, '')
				) {
					let hash = document.querySelector(this.hash);
					if (!hash) {
						hash = document.querySelector('[name=' + this.hash.slice(1) + ']');
					}
					if (hash) {
						e.preventDefault();
						SmoothAnchors.scrollToElement(this.hash);
					}
				}
			});
		});

		const goTopButton = document.getElementById('js-button-go-top');
		if (goTopButton) {
			goTopButton.addEventListener('click', function (e) {
				e.preventDefault();
				SmoothAnchors.scrollToTop();
				return false;
			});
		}
	},

	animateTo: (targetTop) => {
		const startTop = window.scrollY || document.documentElement.scrollTop;
		const distance = targetTop - startTop;
		const duration = scrollSpeed;
		const startTime = performance.now();

		const easeInOutSwing = (t) => {
			return t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t;
		};

		const animate = (currentTime) => {
			const elapsed = currentTime - startTime;
			const progress = Math.min(elapsed / duration, 1);
			const easeProgress = easeInOutSwing(progress);
			const newTop = startTop + distance * easeProgress;

			window.scrollTo(0, newTop);

			if (progress < 1) {
				requestAnimationFrame(animate);
			}
		};

		requestAnimationFrame(animate);
	},

	scrollToElement: (hash) => {
		const element = document.querySelector(hash);
		if (element) {
			const top = element.offsetTop;
			SmoothAnchors.animateTo(top);
			history.pushState(null, null, hash);
		}
	},

	scrollToTop: () => {
		SmoothAnchors.animateTo(0);
	},
};

export default SmoothAnchors;
